import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    List,
    ListItem,
    ListItemText
  } from "@mui/material";


const { useState } = React;

export const CommandsContent = ({ commands }) => {
    let navigate = useNavigate();    
    let location = useLocation();

  const [activeLink, setActiveLink] = useState(null);


  const handleContentClick = (id) => {
    const newLocation = { ...location, hash: `#${id}` };
    navigate(newLocation);
  };
  
  React.useEffect(() => {
    setActiveLink(location.hash);  
  }, [location.hash]);  


  return (
    <List>
      {commands.map((command, index) => {
        return (
          <ListItem
            key={index}
            className={`content-nav ${activeLink === `#command${index}` ? 'active' : ''}`}
            component="a"
            onClick={() => handleContentClick(`command${index}`)}
          >
            <ListItemText primary={command.name} />
          </ListItem>
        );
      })}
    </List>
  );
};
